import CollectionPage from '~/components/module/setup/CollectionPage';
import { setupRouteAbsolute } from '~/utils/routes/setup';
import { medicationAdapter } from '~/apis/medication';
import { str } from '~/components/module/setup/cells';
import { IFormField } from '~/utils/interface/setup';

const fields: IFormField[] = [
  { name: 'name', labelKey: 'pages.setup.medications.name', type: 'text', required: true },
  { name: 'purpose', labelKey: 'pages.setup.medications.purpose', type: 'text' },
  { name: 'dosage', labelKey: 'pages.setup.medications.dosage', type: 'text' },
  { name: 'frequency', labelKey: 'pages.setup.medications.frequency', type: 'text' },
  { name: 'howToTake', labelKey: 'pages.setup.medications.howToTake', type: 'textarea' },
];

const Medications = () => (
  <CollectionPage
    i18nPrefix='pages.setup.medications'
    module='seniorMedical'
    permissionAction='manageMedication'
    backTo={{ path: setupRouteAbsolute.medical, labelKey: 'nav.setup.medical' }}
    adapter={medicationAdapter}
    fields={fields}
    defaultForm={{}}
    getTitle={(form) => str(form.name)}
    columns={[
      { key: 'name', labelKey: 'pages.setup.medications.name', render: (form) => <span className='font-medium text-foreground'>{str(form.name)}</span> },
      { key: 'purpose', labelKey: 'pages.setup.medications.purpose', render: (form) => str(form.purpose) },
      { key: 'dosage', labelKey: 'pages.setup.medications.dosage', render: (form) => str(form.dosage) },
      { key: 'frequency', labelKey: 'pages.setup.medications.frequency', render: (form) => str(form.frequency) },
      { key: 'howToTake', labelKey: 'pages.setup.medications.howToTake', render: (form) => str(form.howToTake) },
    ]}
  />
);

export default Medications;
